const findComboboxSelectedElement = (controlId) => {
  return document.querySelector(`[data-control-id="${controlId}"] [role="option"][data-option-value][aria-selected="true"]`);
};
const moveToPreviousOption = (element) => {
  const options = Array.from(element.querySelectorAll('[role="option"],[role="input"]'));
  const selectedOption = element.querySelector(":focus");
  const selectedIndex = options.indexOf(selectedOption);
  const previousIndex = selectedIndex - 1;
  const previousOption = options[previousIndex];
  if (previousOption && previousOption instanceof HTMLElement) {
    previousOption.focus({
      preventScroll: true
    });
    previousOption.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
    return previousOption;
  }
  return null;
};
const moveToNextOption = (element) => {
  const options = Array.from(element.querySelectorAll('[role="option"],[role="input"]'));
  const selectedOption = element.querySelector(":focus");
  const selectedIndex = options.indexOf(selectedOption);
  const nextIndex = selectedIndex + 1;
  const nextOption = options[nextIndex];
  if (nextOption && nextOption instanceof HTMLElement) {
    nextOption.focus({
      preventScroll: true
    });
    nextOption.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
    return nextOption;
  }
  return null;
};
const moveToElement = (element, querySelector) => {
  const target = element.querySelector(querySelector);
  if (target && target instanceof HTMLElement) {
    target.focus({
      preventScroll: true
    });
    target.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
    return target;
  }
  return null;
};

export { findComboboxSelectedElement, moveToElement, moveToNextOption, moveToPreviousOption };
//# sourceMappingURL=elements.js.map
